import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Traders que trabajan en un horario de 9 a 5 y necesitan efectividad en poco tiempo.', 'Personas que han quemado más de 2 cuentas de fondeo y no entienden por qué.', 'Traders que tienen la técnica pero pierden el control por sus emociones.', "Quienes buscan un sistema tipo 'SOP' (Procedimiento Operativo Estándar) profesional."];
  const notForWho = ["Personas que buscan 'señales' milagrosas sin querer aprender a leer un gráfico.", 'Gamblers que quieren pasar una cuenta de $50k en un solo día arriesgando todo.', 'Quienes no tienen la disciplina mínima para cerrar la laptop después de un trade.'];
  return <section className="py-20" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-17">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-trading-green/10 to-transparent border border-trading-green/20 rounded-2xl p-8" data-id="element-18">
            <h3 className="text-2xl font-heading text-white mb-6 flex items-center gap-3" data-id="element-19">
              <span className="bg-trading-green text-trading-dark p-1 rounded-full" data-id="element-20">
                <CheckIcon className="w-5 h-5" data-id="element-21" />
              </span>
              ESTO ES PARA TI SI:
            </h3>
            <ul className="space-y-4" data-id="element-22">
              {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-23">
                  <CheckIcon className="w-5 h-5 text-trading-green flex-shrink-0 mt-0.5" data-id="element-24" />
                  <span className="text-slate-300 text-sm" data-id="element-25">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is NOT for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gradient-to-b from-trading-red/10 to-transparent border border-trading-red/20 rounded-2xl p-8" data-id="element-26">
            <h3 className="text-2xl font-heading text-white mb-6 flex items-center gap-3" data-id="element-27">
              <span className="bg-trading-red text-white p-1 rounded-full" data-id="element-28">
                <XIcon className="w-5 h-5" data-id="element-29" />
              </span>
              ESTO NO ES PARA TI SI:
            </h3>
            <ul className="space-y-4" data-id="element-30">
              {notForWho.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-31">
                  <XIcon className="w-5 h-5 text-trading-red flex-shrink-0 mt-0.5" data-id="element-32" />
                  <span className="text-slate-300 text-sm" data-id="element-33">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Proof / Believability Block */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto mt-16 bg-trading-card border border-white/10 rounded-xl p-8 text-center relative overflow-hidden" data-id="element-34">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-trading-gold via-trading-amber to-trading-gold" data-id="element-35" />
          <h4 className="text-xl font-heading text-white mb-4" data-id="element-36">
            Lo que cambia en 7 días:
          </h4>
          <p className="text-slate-300 italic" data-id="element-37">
            "Pasarás de la ansiedad de no saber qué hacer, a tener la calma de
            un francotirador. No garantizamos millones, garantizamos que
            operarás con la misma estructura que los traders que ya están
            recibiendo sus primeros pagos (payouts)."
          </p>
        </motion.div>
      </div>
    </section>;
}